function isPBSUrl(url: string) {
  try {
    const urlObj = new URL(url)
    const isPBSUrl = urlObj.hostname === 'pbs.org' || urlObj.hostname === 'www.pbs.org';
    return isPBSUrl
  } catch (_error) {
    return false
  }
}

export default isPBSUrl
